import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { Alert, Box, Button, Dialog, DialogContent } from "@mui/material"

interface QrNoTicketsModalProps {
  open: boolean
  message: string
  onClose: () => void
}

const QrNoTicketsModal: React.FC<QrNoTicketsModalProps> = ({
  open,
  message,
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: "4px",
      },
    }}
  >
    <DialogContent sx={{ p: 2.5, minHeight: 210 }}>
      <Alert
        severity="error"
        icon={<WarningAmberIcon />}
        sx={{
          alignItems: "center",
          bgcolor: "#dc2f34",
          color: "#ffffff",
          fontWeight: 700,
          justifyContent: "center",
          minHeight: 68,
          textAlign: "center",
          "& .MuiAlert-icon": {
            color: "#ffffff",
            mr: 2,
          },
          "& .MuiAlert-message": {
            width: "100%",
          },
        }}
      >
        {message}
      </Alert>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 9 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            bgcolor: "#dc2f34",
            fontWeight: 700,
            "&:hover": { bgcolor: "#c6282d" },
          }}
        >
          Cerrar
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
)

export default QrNoTicketsModal
